import { getDispatchControlValue } from "@mcleod/general";
import { BRLTLOrder, BrltlUtil } from "./brltl/BrltlUtil";
import { QuoteEntryLTL } from "./brltl/QuoteEntryLTL";
import { Orders } from "./Orders";
import { CommonDialogs } from "@mcleod/common";

export class OrderRerateLogic {
    static shouldRerate(ordersLayout: Orders | QuoteEntryLTL): boolean {
        const isTransferredToBilling: boolean = !ordersLayout.activeRow.isNull("xferred2billing_dt");
        if (isTransferredToBilling) return false;

        const sourceFreightGroupItem = ordersLayout.getFreightGroupItemDataSource();
        const sourceStop = ordersLayout.getStopDataSource();
        const sourceHdrXFgp = ordersLayout.getHdrXFgpDataSource();
        const sourceBFG = ordersLayout.getBillingFreightGroupDataSource();
        const brltlData: BRLTLOrder = {
            revenue_code_id: ordersLayout.activeRow.get("revenue_code_id"),
            order_type_id: ordersLayout.activeRow.get("order_type_id"),
            order_mode: ordersLayout.activeRow.get("order_mode"),
            no_freight_group_items: sourceFreightGroupItem.data.length == 0
        };

        if (BrltlUtil.isBRLTLOrder(brltlData) && ordersLayout.activeRow.get("status") != "V") {
            const orderChangedData = ordersLayout.activeRow.getChangedData();
            const stopsChanged = sourceStop.data.some(stop => {
                const changedData = stop.getChangedData();
                return changedData.hasOwnProperty("sched_arrive_early") || changedData.hasOwnProperty("sched_arrive_late") ||
                    changedData.hasOwnProperty("location_id") || changedData.hasOwnProperty("zip_code") ||
                    changedData.hasOwnProperty("city_id") || changedData.hasOwnProperty("appt_required") ||
                    changedData.hasOwnProperty("confirmed");
            });

            const freightItemsChanged = sourceFreightGroupItem.hasChanged();
            const accessorialsChanged = sourceHdrXFgp.hasChanged();
            const billingFreightGroupChanged = !(ordersLayout instanceof QuoteEntryLTL) && sourceBFG.data.filter(row => row.get("bfg_type_code") != "DFLT").some(row => row.hasChanged());

            const rerateConsignedBfgControlValue = getDispatchControlValue("rerate_consigned_bfg");
            const chosenCarrier = sourceBFG.data.some(row => row.get("bfg_status_code") == "CHOS");
            if (chosenCarrier && rerateConsignedBfgControlValue === "N") return false;

            return orderChangedData.hasOwnProperty("customer_id") || orderChangedData.hasOwnProperty("order_type_id") || stopsChanged || billingFreightGroupChanged || freightItemsChanged || accessorialsChanged;
        }
        return false;
    }

    static async promptForRerate(ordersLayout: Orders | QuoteEntryLTL): Promise<boolean> {
        if (!this.shouldRerate(ordersLayout)) {
            return false;
        }

        const sourceBFG = ordersLayout.getBillingFreightGroupDataSource();
        const rerateConsignedBfgControlValue = getDispatchControlValue("rerate_consigned_bfg");
        const chosenCarrier = sourceBFG.data.some(row => row.get("bfg_status_code") == "CHOS");

        if (chosenCarrier && rerateConsignedBfgControlValue === "P") {
            const message = `Updating consigned ${ordersLayout instanceof QuoteEntryLTL ? "quote" : "order"} may affect rates.  Would you like to re-rate?`;
            return await CommonDialogs.showYesNo(message, `Re-rate ${ordersLayout instanceof QuoteEntryLTL ? "Quote" : "Order"}`);
        }
        return true;
    }
}
